import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material';
import PageHeader from '../commons/PageHeader';
import { useMsal } from '@azure/msal-react';
import { login } from '../../services/userService';

function Login() {
  const { instance } = useMsal();

  return (
    <>
      <PageHeader title='' />
      <Box sx={{ justifyItems: 'middle' }}>
        <Card
          sx={{
            width: { xs: '80%', sm: '60%', md: '40%', lg: '30%', xl: '25%' },
            margin: 'auto',
            p: 4,
          }}
        >
          <CardContent>
            <Typography variant='h5' color='primary' sx={{ mb: 4 }}>
              Start here
            </Typography>
            Click the button below to sign in to Event Manager.
          </CardContent>
          <CardActions>
            <Button
              onClick={() => login(instance)}
              variant='contained'
              sx={{ flexGrow: 1 }}
            >
              Sign in
            </Button>
          </CardActions>
        </Card>
      </Box>
    </>
  );
}

export default Login;
